import useUrlState from '../../common/useUrlState';

interface ComparedEventParam {
  event: string;
  tickets?: string[];
}

const useDashboardUrlState = () => useUrlState({
  parse: (params, { string, array }) => ({
    ...params,
    tickets: array(params.tickets, string),
    comparedEvents: (array(params.comparedEvents, (param) => ((
      typeof param === 'object'
        && 'event' in param && typeof param.event === 'string'
        && (!('tickets' in param) || array(param.tickets, string) !== null)
    ) ? param : null)) || []) as ComparedEventParam[],
  }),
});

export default useDashboardUrlState;
